export const allowedCommentsNetworks = ["facebook", "instagram"];